'use client';

import { memo } from 'react';

import FormBlock from '~/shared/components/form-block';
import useSubscription from '~/shared/components/subscription/use-subscription';
import type { Locale } from '~/shared/constants';

import type { SubscriptionFormValues } from './types';

import './subscription.scss';

const initialValues: SubscriptionFormValues = {
  userName: '',
  email: '',
  categories: [],
  termsAndConditions: false,
  captcha: '',
};

export type SubscriptionProps = Readonly<{
  lng: Locale;
}>;

const Subscription = ({ lng }: SubscriptionProps) => {
  const {
    isModalOpen,
    isSubmitting,
    handleModalOpen,
    isSubscribedLocal,
    onModalClose,
    onModalContentClick,
    handleSubmit,
    formConfig,
    t,
  } = useSubscription({ lng });

  return (
    <div className="subscription">
      {isSubscribedLocal ? (
        <div className="subscription__status">{t('text.subscribed')}</div>
      ) : (
        <button type="button" className="subscription__trigger" onClick={handleModalOpen} disabled={isSubmitting}>
          {t('button.subscription-open-modal')}
        </button>
      )}

      {isModalOpen && (
        <div className="subscription__overlay" onClick={onModalClose}>
          <div
            className="subscription__modal"
            role="dialog"
            aria-modal="true"
            aria-label={t('text.subscription-text')}
            onClick={onModalContentClick}
          >
            <div className="subscription__header">
              <div className="subscription__title">{t('text.subscription-text')}</div>

              <button
                type="button"
                className="subscription__close"
                onClick={onModalClose}
                aria-label="Close subscription modal"
              >
                ×
              </button>
            </div>

            <div className="subscription__content">
              <FormBlock<SubscriptionFormValues>
                formConfig={formConfig}
                initialValues={initialValues}
                onSubmit={handleSubmit}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default memo(Subscription);
